import { useNavigation, useShow, useTable } from '@pankod/refine-core'
import {
  List,
  RefreshButton,
  Table,
  Space,
  DeleteButton,
  Icons,
  Typography,
  DateField,
  useModalForm,
  useModal,
  CreateButton,
  EditButton,
  Input,
  Row,
  Col,
  Button,
  notification,
} from '@pankod/refine-antd'
import type { NotificationPlacement } from 'antd/es/notification'
import { TableColumnsType, Tag } from 'antd'
import { getUsersList, getUsersListAdmin, resendVerificationMail } from 'users'
import { useState, useEffect } from 'react'
import { IWorkRequest } from 'interfaces'
import { UserCreate } from 'pages/users/create'
import { UserEdit } from 'pages/users/edit'
import { useUserContext } from 'context/user'
const { PlusOutlined, AppstoreOutlined, CopyOutlined } = Icons

const { Text, Link } = Typography
const { Search } = Input
interface IUser {
  id: string
  displayName: string
  email: string
  defaultRole: string
  phoneNumber: string
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
  roles: object[]
  emailVerified:boolean
}
export const UserManagementTable = () => {
  const { show } = useNavigation()
  const { userRole } = useUserContext()
  const [refresh, setRefresh] = useState(false)
  const [userList, setUserList] = useState([] as any[])
  const [userRecord, setUserRecord] = useState([])
  const [limit, setLimit] = useState(10)
  const [offset, setOffSet] = useState(0)
  const [condition, setCondition] = useState({})
  const [searchText, setSearchText] = useState('')
  const [tableTotal, setTableTotal] = useState(0 as any | undefined)
  const metaData = {
    fields: ['id', 'disabled', 'displayName', 'defaultRole', 'email', 'password'],
  }
  let sic_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator']
  let pm_roles = ['qcreator', 'qreviewer', 'qapprover', 'variantcreator', 'subjectincharge', ' papersetter', 'paperapprover']
  const sic_filter = `roles:{role:{_in:${JSON.stringify(sic_roles)}}}`
  const pm_filter = `roles:{role:{_in:${JSON.stringify(pm_roles)}}}`
  const getUsers = async () => {
    if (userRole === 'subjectincharge') {
      getUsersList(limit, offset, sic_filter, searchText).then((response: any) => {
        setUserList(response?.users)
        setTableTotal(response?.usersAggregate?.aggregate?.count)
      })
    }
    if (userRole === 'productmanager') {
      getUsersList(limit, offset, pm_filter, searchText).then((response: any) => {
        setUserList(response?.users)
        setTableTotal(response?.usersAggregate?.aggregate?.count)
      })
    }

    else if (userRole === 'admin' || userRole === 'srmanager') {
      getUsersListAdmin(limit, offset, searchText).then((response: any) => {
        setUserList(response?.users)
        setTableTotal(response?.usersAggregate?.aggregate?.count)
      })
    }
  }
  const openNotification = (placement: NotificationPlacement, message: string) => {
    notification.success({
      message: `Notification`,
      description: message,
      placement,
    })
    // refreshTable()
  }
  useEffect(() => {
    getUsers()
  }, [refresh, userRole, searchText])
  const getUserDetails = (record: any) => {
    setUserRecord(record)
    editShow()
  }
  const {
    modalProps,
    formProps,
    close: close,
    show: createShow,
  } = useModalForm({
    resource: 'users',
    action: 'create',
    autoSubmitClose: true,
  })
  const {
    formProps: editFormProps,
    modalProps: editModalProps,
    show: editShow,
    close: editClose,
  } = useModalForm({
    // resource: "users",
    action: 'edit',
  })
  const columns: TableColumnsType<IUser> = [
    // {
    //   dataIndex: "id",
    //   title: "Id",

    // },
    {
      dataIndex: 'displayName',
      title: 'User Name',
    },
    {
      dataIndex: 'email',
      title: 'Email id',
    },
    {
      dataIndex: 'defaultRole',
      title: 'Primary Role',
    },
    {
      dataIndex: 'defaultRole',
      title: 'Roles',
      render: (_, { roles }) => (
        <>
          {roles.map((tag: any, i) => {
            return tag?.role !== 'user' && tag?.role !== 'me' && <Tag key={i}>{tag?.role?.toUpperCase()}</Tag>
          })}
        </>
      ),
    },
    {
      dataIndex: 'disabled',
      title: 'Active',
      render: value => (
        <Tag color={value ? 'red' : 'green'} key={value}>
          {value ? 'INACTIVE' : 'ACTIVE'}
        </Tag>
      ),

      //  return (
      //       <Tag color={color} key={tag}>
      //         {tag.toUpperCase()}
      //       </Tag>
      //     );
    },
    {
      dataIndex: 'type',
      title: 'Type',
      render: (_, record) => (
        record?.email?.substring(record?.email.indexOf("@") + 1, record?.email?.length) !== 'centa.org' ? <Tag color='pink'>External</Tag> : <Tag color='blue'>Internal</Tag>
        // console.log("mmmmmm", )
      )
    },
    {
      dataIndex: 'createdAt',
      title: 'Created_at',
      render: value => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Updated_at',
      dataIndex: 'updatedAt',
      render: value => <DateField format="DD-MMM-YY" value={value} />,
    },
    {
      title: 'Last seen',
      dataIndex: 'lastSeen',
      render: value => (value !== null ? <DateField format="DD-MMM-YY" value={value} /> : ''),
    },
    {
      title: 'Actions',
      dataIndex: 'actions',
      render: (_, record) => (
        <Space>
          {/* {editPermission?.granted ? ( */}
          {console.log(record)}

          <EditButton
            size="small"
            type="link"
            hideText
            // hidden={userRole === 'productmanager' && record?.roles?.}
            title="Edit"
            recordItemId={record.id}
            onClick={() => {
              getUserDetails(record)
              // editShow(record.id);
            }}
          />
          <Button type='primary' hidden={record?.emailVerified} onClick={()=>resendVerificationMail(record?.email).then((resp)=>  openNotification('bottomRight', 'Verification Sent'))}> Resend Verification</Button>
        </Space>
      ),
    },
  ]

  const changeValue = () => { }
  const onChange = (page: number, pageSize?: any): void => {
    let offsetValue = (page - 1) * limit
    setOffSet(offsetValue)
    let limitValue = pageSize > 10 ? pageSize : limit
    // setCurrent(page)
    setLimit(pageSize)
    let condition = ''
    if (userRole === 'subjectincharge') {
      getUsersList(limitValue, offsetValue, sic_filter, searchText).then((response: any) => {
        setUserList(response?.users)
        setTableTotal(response?.usersAggregate?.aggregate?.count)
      })
    } else if (userRole === 'admin' || userRole === 'srmanager') {
      getUsersListAdmin(limitValue, offsetValue, searchText).then((response: any) => {
        setUserList(response?.users)
        setTableTotal(response?.usersAggregate?.aggregate?.count)
      })
    }
  }
  const refreshData = () => {
    setTimeout(getUsers, 3000)
    // getUsers()
  }
  const onSearch = (value: string) => {
    setSearchText(value)
  }
  console.log({userList})

  return (
    <List
      pageHeaderProps={{
        extra: [<RefreshButton onClick={() => getUsers()} />,

        <CreateButton type="primary" icon={<PlusOutlined />} onClick={() => createShow()} />],
      }}
    >
      <Row style={{ marginBottom: 20, display: 'flex', justifyContent: 'flex-end' }}>
        <Col lg={8} xs={24}>
          <Search placeholder="Search By Name" allowClear enterButton="Search" size="large" onSearch={onSearch} />
        </Col>
      </Row>
      <Table
       size="small"
       scroll={{ x: 1500 }}
        columns={columns}
        dataSource={userList}
        pagination={{
          total: tableTotal,
          onChange,
        }}
      />

      <UserCreate modalProps={modalProps} formProps={formProps} close={close} refreshData={refreshData} />
      <UserEdit modalProps={editModalProps} formProps={editFormProps} close={editClose} record={userRecord} refreshData={refreshData} />

      {/* <Pagination total={pageCount} current={current} setCurrent={setCurrent} /> */}
    </List>
  )
}
